import type { SelectorOption } from '../../../Components/common';

export { STYLE_OPTIONS } from '../v3/constants';

export const PRIORITY_OPTIONS: SelectorOption[] = [
    { label: 'Cost', value: 'cost' },
    { label: 'Basic', value: 'basic' },
    { label: 'Standard', value: 'standard' },
    { label: 'Premium', value: 'premium' },
];

export enum GENERATE_LOGO_V4_CULTURE {
    EnUs = 'en-us',
    FrFr = 'fr-fr',
    FrBe = 'fr-be',
    FrCh = 'fr-ch',
    DeDe = 'de-de',
    DeAt = 'de-at',
    DeCh = 'de-ch',
    EsEs = 'es-es',
    EsUs = 'es-us',
    EnCa = 'en-ca',
    EnIn = 'en-in',
    EnSg = 'en-sg',
    EnAu = 'en-au',
    EnNz = 'en-nz',
    EnGb = 'en-gb',
    EnIe = 'en-ie',
    ItIt = 'it-it',
    ItCh = 'it-ch',
    NlNl = 'nl-nl',
    NlBe = 'nl-be',
    SvSe = 'sv-se',
    NbNo = 'nb-no',
    DaDk = 'da-dk',
    FiFi = 'fi-fi',
    PtPt = 'pt-pt',
}

export const CULTURE_VALUE_OPTIONS: SelectorOption[] = Object.values(GENERATE_LOGO_V4_CULTURE).map((culture) => ({
    label: culture,
    value: culture,
}));
